let el
let platform
let map
let location
let mapZoom

export function Map() {
    el = document.querySelector('.js-map')
    if (!el) {
        return
    }

    let { lat, lng, zoom } = el.dataset
    lat ||= 51.235124
    lng ||= -1.118506
    mapZoom = zoom || 12
    location = {
        lat,
        lng
    }

    import('@here/maps-api-for-javascript')
        .then((m) => m.default)
        .then(initMaps)
}

function initMaps(H) {
    platform = new H.service.Platform({
        apikey: 'Ps6e2YeA1xwwNx4BuewJiSk2PmmMjNYFbQj0oSWLaew'
    })

    var defaultLayers = platform.createDefaultLayers()
    map = new H.Map(el, defaultLayers.vector.normal.map, {
        zoom: mapZoom,
        center: location,
        pixelRatio: window.devicePixelRatio || 1
    })
    window.addEventListener('resize', () => map.getViewPort().resize())
    var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map))
    var ui = H.ui.UI.createDefault(map, defaultLayers)

    addMarkers(H)
}

function addMarkers(H) {
    const dxIcon = new H.map.Icon('../images/dx-marker.png', {
        size: {
            w: 35,
            h: 53
        },
        anchor: {
            x: 15,
            y: 51
        }
    })

    // map.addObject(new H.map.Marker(location, { icon: dxIcon }))

    if (window.mapMarkers) {
        window.mapMarkers.forEach((loc) => {
            map.addObject(new H.map.Marker(loc, { icon: dxIcon }))
        })
    }
}
